import { render, staticRenderFns } from "./ImprestDimensions.vue?vue&type=template&id=7396dbe2"
import script from "./ImprestDimensions.vue?vue&type=script&lang=js"
export * from "./ImprestDimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports